import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../state/store";
import Button from "../../Button";
import { PlusIcon } from "@heroicons/react/24/outline";
import { AgencyPolicyType } from "../../../models/PolicyMarket";
import { useState } from "react";
import { EditAgencyAvailableMarkteModal } from "./EditAgencyAvailableMarketModal";

export const AgencyAvailableMarketModule = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const agencyAvailableMarkets = useSelector((state: RootState) => state.policyMarkets.agencyPolicyTypes);

    const [ showEditAgencyAvailableMarketModal, setShowEditAgencyAvailableMarketModal] = useState<{
        show: boolean;
        agencyAvailableMarkets?: AgencyPolicyType[]
    }>({ show: false, agencyAvailableMarkets: undefined });

    return(
        <>
            <EditAgencyAvailableMarkteModal
                info={showEditAgencyAvailableMarketModal}
                onClose={() => setShowEditAgencyAvailableMarketModal({show: false, agencyAvailableMarkets: undefined})}
            />
            <div className="text-black max-h-full p-5 md:w-full">
                <div className="flex justify-between w-full">
                    <div className="text-md font-bold text-black pl-3 mt-2">
                        {t("AVAILABLE_MARKETS")}
                    </div>
                    <Button onClick={() => setShowEditAgencyAvailableMarketModal({show: true, agencyAvailableMarkets: agencyAvailableMarkets})}>
                        <span className="flex items-center font-semibold pr-3">
                            <div className="w-8 p-1 aspect-square mr-2">
                                <PlusIcon />
                            </div>
                            {t("EDIT_AVAILABLE_MARKETS")}
                        </span>
                    </Button>
                </div>

                <div className="py-5 w-full flex flex-wrap">
                    {
                        agencyAvailableMarkets.map((market) => {
                            return(
                                <div className="w-full sm:w-1/2 xl:w-1/3 pt-5 px-5">
                                    <div className="text-center">
                                        <label className="tracking-wide text-black font-bold text-lg mb-2">
                                            {market.market_name}
                                        </label>
                                    </div>
                                    <hr className="bg-blue mb-5 h-0.5"></hr>
                                    <div className="w-full pl-3 pr-3">
                                        <ul className="list-disc list-inside ml-3">
                                            {
                                                market.policy_types.map((type, index) => {
                                                return(
                                                    <li className="text-black text-base">{type.name}</li>
                                                )})
                                            }
                                        </ul>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </>
    )
}